(() => {
 if (window.acArtistLinkedLoaded) return;
 window.acArtistLinkedLoaded = true;
 const ready = new WeakSet();
 const read = key => { try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value : []; } catch { return []; } };
 const updateSaves = () => {
  document.querySelectorAll('[data-ac-linked-save]').forEach(b => b.setAttribute('aria-pressed', String(read('ac-saved-artworks').includes(b.dataset.acLinkedSave))));
  document.querySelectorAll('[data-ac-follow]').forEach(b => {
   const active = read('ac-followed-artists').includes(b.dataset.acFollow);
   b.setAttribute('aria-pressed', String(active));
   const label = b.querySelector('[data-ac-follow-label]');
   if (label) { if (!label.dataset.baseLabel) label.dataset.baseLabel = label.textContent; label.textContent = active ? 'Following' : label.dataset.baseLabel; }
  });
 };
 const toggleSave = (key, id) => {
  const values = read(key);
  try { localStorage.setItem(key, JSON.stringify(values.includes(id) ? values.filter(v => v !== id) : [...values, id])); updateSaves(); return true; } catch { return false; }
 };
 const start = () => {
  document.querySelectorAll('[data-ac-artist-linked]').forEach(root => {
   if (ready.has(root)) return;
   ready.add(root);
   const tabs = [...root.querySelectorAll('[data-ac-tab]')];
   const panels = [...root.querySelectorAll('[data-ac-panel]')];
   const selectTab = tab => {
    tabs.forEach(t => { t.setAttribute('aria-selected', String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
    panels.forEach(panel => { panel.hidden = panel.dataset.acPanel !== tab.dataset.acTab; });
   };
   tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => selectTab(tab));
    tab.addEventListener('keydown', e => {
     let next;
     if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
     if (e.key === 'ArrowLeft') next = tabs[(i + tabs.length - 1) % tabs.length];
     if (e.key === 'Home') next = tabs[0];
     if (e.key === 'End') next = tabs.at(-1);
     if (next) { e.preventDefault(); selectTab(next); next.focus(); }
    });
   });
   if (tabs.length) selectTab(tabs[0]);
   const gallery = root.querySelector('[data-ac-gallery]');
   if (gallery) {
    const images = [...gallery.querySelectorAll('img')];
    const dots = [...root.querySelectorAll('[data-ac-dot]')];
    const show = index => { images.forEach((img,i) => { img.hidden = i !== index; }); dots.forEach((dot,i) => dot.setAttribute('aria-current', String(i === index))); };
    dots.forEach((dot,i) => dot.addEventListener('click', () => show(i)));
    if (images.length) show(0);
   }
   const track = root.querySelector('[data-ac-track]');
   const bar = root.querySelector('[data-ac-progress]');
   if (track && bar) {
    const progress = () => {
     const width = Math.min(100, Math.max(12, track.clientWidth / Math.max(track.scrollWidth, 1) * 100));
     const ratio = track.scrollWidth > track.clientWidth ? track.scrollLeft / (track.scrollWidth - track.clientWidth) : 0;
     bar.style.width = width + '%';
     bar.style.transform = 'translateX(' + ratio * (100 - width) / width * 100 + '%)';
    };
    track.addEventListener('scroll', progress, {passive:true});
    new ResizeObserver(progress).observe(track);
    root.addEventListener('load',progress,true);
    progress();
   }
   const dialog = root.querySelector('[data-ac-inquiry-dialog]');
   if (dialog) {
    root.querySelector('[data-ac-inquiry-open]')?.addEventListener('click', () => dialog.showModal());
    dialog.querySelector('[data-ac-inquiry-close]').addEventListener('click', () => dialog.close());
    if (dialog.querySelector('[data-ac-inquiry-result]')) dialog.showModal();
   }
   root.addEventListener('click', async event => {
    const save = event.target.closest('[data-ac-linked-save]');
    const follow = event.target.closest('[data-ac-follow]');
    if (save || follow) {
     const ok = save ? toggleSave('ac-saved-artworks', save.dataset.acLinkedSave) : toggleSave('ac-followed-artists', follow.dataset.acFollow);
     if (!ok) { const button = save || follow; button.title = 'Saving is unavailable in this browser.'; }
    }
    const sort = event.target.closest('[data-ac-linked-sort]');
    if (sort) {
     const url = new URL(location.href);
     url.searchParams.set('sort_by', sort.dataset.acLinkedSort);
     url.searchParams.delete('page');
     url.hash = root.id;
     sort.closest('details').removeAttribute('open');
     location.assign(url);
     return;
    }
    const more = event.target.closest('[data-ac-linked-more]');
    if (!more) return;
    event.preventDefault();
    if (more.getAttribute('aria-busy') === 'true') return;
    more.setAttribute('aria-busy','true');
    const scope = root.querySelector('[data-ac-linked-collection]');
    const status = scope.querySelector('[data-ac-linked-status]');
    status.textContent = 'Loading artworks…';
    try {
     const url = new URL(more.href);
     const current = new URL(location.href);
     ['preview_theme_id','view','sort_by'].forEach(key => { if (current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key)); });
     url.searchParams.set('section_id',scope.dataset.acLinkedCollection);
     const response = await fetch(url);
     if (!response.ok) throw new Error('Request failed');
     const doc = new DOMParser().parseFromString(await response.text(),'text/html');
     const result = doc.querySelector('[data-ac-linked-collection]');
     if (!result) throw new Error('Missing section');
     const existing = new Set([...scope.querySelectorAll('[data-ac-linked-product]')].map(el => el.dataset.acLinkedProduct));
     const cards = [...result.querySelectorAll('[data-ac-linked-grid] > [data-ac-linked-product]')].filter(card => !existing.has(card.dataset.acLinkedProduct));
     if (!cards.length) throw new Error('No new artworks');
     scope.querySelector('[data-ac-linked-grid]').append(...cards);
     const next = result.querySelector('[data-ac-linked-more]');
     if (next) { more.href = next.href; more.removeAttribute('aria-busy'); } else more.remove();
     updateSaves();
     status.textContent = cards.length + ' more artworks loaded.';
    } catch { more.removeAttribute('aria-busy'); status.textContent = 'Unable to load artworks. Please try again.'; }
   });
  });
  updateSaves();
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
 document.addEventListener('shopify:section:load', start);
 addEventListener('storage', updateSaves);
})();
